export interface TagsPage {
  country: string;
  vesselId: string;
  sceCode: string;
}
export interface VesselsPageProps {
  country: string;
}

export interface VesselPageProps {
  country: string;
  vesselId: string;
}

export interface GenericPageProps {
  country: string;
  vesselId: string;
  mahCode?: string;
  sceCode?: string;
}

export interface WonosWithScePagesProps {
  country: string;
  vesselId: string;
  mahCode: string;
  sceCode: string;
}

export interface MahPageProps {
  country: string;
  vesselId: string;
  sceCode: string;
}

export interface BowtiePageProps {
  country: string;
  vesselId: string;
  mahCode: string;
}

export interface TagsAndWOsPageProps {
  country: string;
  vesselId: string;
  sceCode: string;
}

export interface CsgTagsAndWOsPageProps {
  country: string;
  vesselId: string;
  csgCode: string;
}

export interface CaseToOperatePageProps {
  country: string;
  vesselId: string;
  search?: string;
}

export interface CaseToOperateFormPageProps {
  country: string;
  vesselId: string;
  ctoId: string;
}

//REFACTOR CTO: Rename ctoId to ctoCode
export interface RoutesProps {
  country: string;
  vesselId: string;
  mahCode: string;
  sceCode: string;
  workOrderId: string;
  ctoId: string;
}

const vesselRoute = "/:country/facilities/:vesselId";
export const Routes = {
  //ERRORS
  NotFound: "/error/not-found",

  //GENERAL
  HomePage: "/",
  LoginPage: "/login",
  FacilitiesPage: "/:country/facilities",

  //MAH
  MahsPage: `${vesselRoute}/mahs`,
  MahsByScePage: `${vesselRoute}/sces/:sceCode/mahs-by-sce`,

  //SCE
  ScesPage: `${vesselRoute}/sces`,

  //TAG
  TagsPage: `${vesselRoute}/tags`,
  TagsPageForSce: `${vesselRoute}/sces/:sceCode`, //TODO: colocar o /tags
  TagsAndWOsPage: `${vesselRoute}/sces/:sceCode/tagsAndWorkOrders`,
  CsgTagsAndWOsPage: `${vesselRoute}/csgs/:csgCode/tagsAndWorkOrders`,

  //WO
  WonosPages: `${vesselRoute}/work-orders`,

  //CTO
  CaseToOperatePage: `${vesselRoute}/cto-list`,
  CaseToOperateDashboard: `${vesselRoute}/case-to-operate/dashboard`,
  CaseToOperate: `${vesselRoute}/case-to-operate`,
  CaseToOperateFormPage: `${vesselRoute}/case-to-operate/:ctoId/details`,

  //BOWTIE
  BowtiePage: `${vesselRoute}/mahs/:mahCode/bowtie`,

  //USER PERMISSIONS
  UserPermissionsPage: "/user-permissions",
  GroupPermissionsPage: "/user-permissions/group-permissions",

  //REDIRECTS
  CountryRedirect: "/:country",
  VesselRedirect: `${vesselRoute}`,
  BowtieRedirect: `${vesselRoute}/mahs/:mahCode`,

  //PROBABLY NOT USED
  WonosWithScePages: `${vesselRoute}/mahs/:mahCode/sces/:sceCode/work-orders`,
};

export const RoutesReplacer = {
  FacilitiesPage: ({ country }: VesselsPageProps) => `/${country}/facilities`,

  //MAH
  MahsPage: ({ country, vesselId }: VesselPageProps) =>
    `/${country}/facilities/${vesselId}/mahs`,

  MahsByScePage: ({ country, vesselId, sceCode }: MahPageProps) =>
    `/${country}/facilities/${vesselId}/sces/${sceCode}/mahs-by-sce`,

  //SCE
  ScesPage: ({ country, vesselId }: GenericPageProps) =>
    `/${country}/facilities/${vesselId}/sces`,

  //TAG
  TagsPage: ({ country, vesselId }: GenericPageProps) =>
    `/${country}/facilities/${vesselId}/tags`,

  TagsAndWOsPage: ({ country, vesselId, sceCode }: TagsAndWOsPageProps) =>
    `/${country}/facilities/${vesselId}/sces/${sceCode}/tagsAndWorkOrders`,

  CsgTagsAndWOsPage: ({ country, vesselId, csgCode }: CsgTagsAndWOsPageProps) =>
    `/${country}/facilities/${vesselId}/csgs/${csgCode}/tagsAndWorkOrders`,

  TagsPageForSce: ({ country, vesselId, sceCode }: TagsPage) =>
    `/${country}/facilities/${vesselId}/sces/${sceCode}`,

  //WO
  WonosPage: ({ country, vesselId }: GenericPageProps) =>
    `/${country}/facilities/${vesselId}/work-orders`,

  //BOWTIE
  BowtiePage: ({ country, vesselId, mahCode }: BowtiePageProps) =>
    `/${country}/facilities/${vesselId}/mahs/${mahCode}/bowtie`,

  //CTO
  CaseToOperatePage: ({ country, vesselId, search }: CaseToOperatePageProps) =>
    `/${country}/facilities/${vesselId}/cto-list${
      search ? `?search=${search}` : ""
    }`,

  CaseToOperateFormPage: ({
    country,
    vesselId,
    ctoId,
  }: CaseToOperateFormPageProps) =>
    `/${country}/facilities/${vesselId}/case-to-operate/${ctoId}/details`,

  CaseToOperateDashboard: ({ country, vesselId }: CaseToOperatePageProps) =>
    `/${country}/facilities/${vesselId}/case-to-operate/dashboard`,

  //PROBABLY NOT USED
  WonosWithScePages: ({
    country,
    vesselId,
    sceCode,
    mahCode,
  }: WonosWithScePagesProps) =>
    `/${country}/facilities/${vesselId}/mahs/${mahCode}/sces/${sceCode}/work-orders`,
};
